module.exports = __webpack_public_path__ + "images/emoji/cinema.f48b3e56bc34862c61b7.png";